import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

// Copia local de `ui/lib/utils`. `packages/ui` no se importa desde acá: todos
// sus componentes son de cliente (Radix, cmdk, recharts) y forzarían
// hidratación, que compite con `page.pdf()`.
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
